import { FC } from "react";
import { Release } from "models/release";

interface ReleaseRowProps {
    release: Release;
    onClick: React.MouseEventHandler<HTMLTableRowElement>;
    isSelected: boolean;
    isLatest: boolean;
    isCollapsed: boolean;
    toggleCollapse: () => void;
    canCollapse: boolean;
}

const renderSign = (
    isCollapsed: boolean,
    isLatest: boolean,
    canCollapse: boolean
) => {
    if (!isLatest) return ":";
    if (canCollapse) {
        return isCollapsed ? "+" : "-";
    }
    return undefined;
};

const ReleaseRow: FC<ReleaseRowProps> = ({
    release,
    onClick,
    isSelected,
    isCollapsed,
    toggleCollapse,
    isLatest,
    canCollapse,
}) => {
    if (!isLatest && isCollapsed) {
        return null;
    }
    return (
        <tr
            onClick={onClick}
            style={isSelected ? { fontWeight: "bold" } : undefined}
        >
            <td className={"text-center"} onClick={toggleCollapse}>
                {renderSign(isCollapsed, isLatest, canCollapse)}
            </td>
            <td>{isLatest ? release.extension : null}</td>
            <td>{release.version}</td>
            <td>
                {release.files.length === 0 && release.module === "Workflow"?
                    <li>
                        <a href={release.url}>{release.url}</a>
                    </li> :
                    release.files.map((file, i) => (
                        <li key={i}>
                            <a href={file.url}>{file.name}</a>
                        </li>
                    ))
                }
            </td>
        </tr>
    );
};

export default ReleaseRow;
